module.exports = __webpack_public_path__ + "img/icon_traitor.d6699d1f.png";